import { mutatorAction } from 'satcheljs';
import Campaign from '../store/Campaign';
import getStore from '../store/store';

export const setCampaignVisibility = mutatorAction(
    'setCampaignVisibility',
    <T>(campaign: Campaign<T>, isVisible: boolean) => {
        getStore().campaignVisibleMap.set(campaign, isVisible);
    }
);
